<app-indeterminate-loader *ngIf="loadingState" [position]="'sticky'" [top]="'0'" [left]="'0'"></app-indeterminate-loader>

<div class="p-6 space-y-6">
    <section>
        <div class="flex justify-between items-start flex-col sm:flex-row md:flex-col xl:flex-row gap-4">
            <div>
                <div class="flex items-center mb-1 gap-2">
                    <button ngxTippy data-tippy-content="Ayuda">
                        <i class="fa-duotone fa-circle-question text-slate-400" style="font-size: 1.5rem;"></i>
                    </button>
                    <h3 class="text-xl leading-snug text-slate-800 font-bold">Autorizar usuarios</h3>
                </div>
                <div class="text-sm">
                    Falta texto de negocio
                </div>
            </div>
            <div class="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                <a  class="btn hover:bg-gl-blue-hover bg-gl-blue text-white">
                    <svg class="w-4 h-4 fill-current opacity-50 shrink-0" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z"></path>
                    </svg>
                    <span class="hidden xs:block ml-2">Asignar Usuarios</span>
                </a>
            </div>
        </div>
    </section>
    <section>
        <div class="grid grid-cols-12 gap-4 mt-5">
            <div class="col-span-12">
                <header class="pb-4">
                    <div class="flex items-baseline flex-col gap-4 xs:flex-row xs:items-center justify-between">
                        <div class="w-full xs:w-auto flex items-center xs:justify-between gap-4">
                            <form class="relative">
                                <label for="action-search" class="sr-only">Buscar</label>
                                <input id="action-search" class="w-full form-input focus:border-slate-300 max-w-full min-w-0 !pl-9" type="search" placeholder="Buscar…">
                                <button class="absolute inset-0 right-auto group pointer-events-none" type="submit">
                                    <svg class="w-4 h-4 shrink-0 fill-current text-slate-400 group-hover:text-slate-500 ml-3 mr-2" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"></path>
                                        <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z"></path>
                                    </svg>
                                </button>
                            </form>
                        </div>
                        <h2 class="font-semibold text-slate-800">Usuarios <span class="text-slate-400 font-medium">3</span></h2>
                    </div>
                </header>
                <div class="overflow-x-auto -mx-6 ">
                    <table class="table-auto w-full">
                        <thead class="text-xs font-semibold uppercase text-slate-500 bg-slate-50 border-t border-b border-slate-200">
                            <tr>
                                <th class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
                                    <div class="flex items-center">
                                        <label class="inline-flex">
                                            <span class="sr-only">Select all</span>
                                            <input id="parent-checkbox" class="form-checkbox" type="checkbox">
                                        </label>
                                    </div>
                                </th>
                                <th class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div class="font-semibold text-left">Promoción</div>
                                </th>
                                <th class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div class="font-semibold text-left">Boleto</div>
                                </th>
                                <th class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div class="font-semibold text-left">Visibilidad</div>
                                </th>
                                <th class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div class="font-semibold text-left">Url</div>
                                </th>
                                <th class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <span class="sr-only">Menu</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="text-sm divide-y divide-slate-200 border-b border-slate-200">
                            <tr *ngFor="let promotion of [1,2,3,4,5,6,7,8]; let i = index;">
                                <td class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
                                    <div class="flex items-center">
                                        <label class="inline-flex">
                                            <span class="sr-only">Select</span>
                                            <input class="table-item form-checkbox" type="checkbox">
                                        </label>
                                    </div>
                                </td>
                                <td class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div class="font-medium text-slate-800">Promocion XX</div>
                                </td>
                                <td class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div class="text-left">Promocion XX</div>
                                </td>
                                <td class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div class="text-left"></div>
                                </td>
                                <td class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                    <div class="text-left"></div>
                                </td>
                                <td class="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
                                    <div class="relative inline-flex">
                                        <ngx-tippy-singleton [singletonProps]="{allowHTML: true, animation: 'shift-away', interactiveBorder: 30, interactiveDebounce: 75, moveTransition: 'transform 0.2s ease-out', theme: 'light'}">
                                            <div class="flex gap-2">
                                                <!-- <a [routerLink]="'../id_season/edit'" class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white h-fit px-1" ngxTippy data-tippy-content="Editar" data-tippy-singleton>
                                                    <div class="w-6 h-6 grid place-content-center">
                                                        <i class="fa-duotone fa-pen-to-square" style="font-size: 1rem;"></i>
                                                    </div>
                                                </a>
                                                <a [routerLink]="'../id_season'" class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white h-fit px-1" ngxTippy data-tippy-content="Funciones" data-tippy-singleton>
                                                    <div class="w-6 h-6 grid place-content-center">
                                                        <i class="fa-duotone fa-calendar-star" style="font-size: 1rem;"></i>
                                                    </div>
                                                </a>
                                                <a [routerLink]="'../id_experience/calendar'" class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white h-fit px-1" ngxTippy data-tippy-content="Ver en Calendario" data-tippy-singleton>
                                                    <div class="w-6 h-6 grid place-content-center">
                                                        <i class="fa-duotone fa-calendar-days" style="font-size: 1rem;"></i>
                                                    </div>
                                                </a> -->
                                                <a class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white h-fit px-1" ngxTippy data-tippy-content="Editar" data-tippy-singleton>
                                                    <div class="w-6 h-6 grid place-content-center">
                                                        <i class="fa-duotone fa-pen-to-square" style="font-size: 1rem;"></i>
                                                    </div>
                                                </a>
                                                <a  class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white h-fit px-1" ngxTippy data-tippy-content="Funciones" data-tippy-singleton>
                                                    <div class="w-6 h-6 grid place-content-center">
                                                        <i class="fa-duotone fa-calendar-star" style="font-size: 1rem;"></i>
                                                    </div>
                                                </a>
                                                <a class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white h-fit px-1" ngxTippy data-tippy-content="Ver en Calendario" data-tippy-singleton>
                                                    <div class="w-6 h-6 grid place-content-center">
                                                        <i class="fa-duotone fa-calendar-days" style="font-size: 1rem;"></i>
                                                    </div>
                                                </a>
                                                <button class="btn-sm bg-rose-500 hover:bg-rose-600 text-white h-fit px-1" ngxTippy data-tippy-content="Suspender" data-tippy-singleton>
                                                    <div class="w-6 h-6 grid place-content-center">
                                                        <i class="fa-duotone fa-hand" style="font-size: 1rem; --fa-primary-opacity: 0.4; --fa-secondary-opacity: 1;"></i>
                                                    </div>
                                                </button>
                                            </div>
                                        </ngx-tippy-singleton>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </section>
    <section>
        <div class="flex flex-col sm:flex-row items-center sm:justify-between gap-4">
            <nav class="flex mb-0 sm:order-1">
                <div class="mr-2">
                    <span class="inline-flex items-center justify-center rounded leading-5 px-2.5 py-2 bg-white border border-slate-200 text-slate-300">
                        <span class="sr-only">Previous</span><wbr>
                        <svg class="h-4 w-4 fill-current" viewBox="0 0 16 16">
                            <path d="M9.4 13.4l1.4-1.4-4-4 4-4-1.4-1.4L4 8z"></path>
                        </svg>
                    </span>
                </div>
                <ul class="inline-flex text-sm font-medium -space-x-px shadow-sm">
                    <li>
                        <span class="inline-flex items-center justify-center rounded-l leading-5 px-3.5 py-2 bg-white border border-slate-200 text-gl-blue">1</span>
                    </li>
                    <li>
                        <a class="inline-flex items-center justify-center leading-5 px-3.5 py-2 bg-white hover:bg-gl-blue border border-slate-200 text-slate-600 hover:text-white">2</a>
                    </li>
                    <li>
                        <a class="inline-flex items-center justify-center leading-5 px-3.5 py-2 bg-white hover:bg-gl-blue border border-slate-200 text-slate-600 hover:text-white">3</a>
                    </li>
                    <li>
                        <span class="inline-flex items-center justify-center leading-5 px-3.5 py-2 bg-white border border-slate-200 text-slate-400">…</span>
                    </li>
                    <li>
                        <a class="inline-flex items-center justify-center rounded-r leading-5 px-3.5 py-2 bg-white hover:bg-gl-blue border border-slate-200 text-slate-600 hover:text-white">9</a>
                    </li>
                </ul>
                <div class="ml-2">
                    <a class="inline-flex items-center justify-center rounded leading-5 px-2.5 py-2 bg-white hover:bg-gl-blue border border-slate-200 text-slate-600 hover:text-white shadow-sm">
                        <span class="sr-only">Next</span><wbr>
                        <svg class="h-4 w-4 fill-current" viewBox="0 0 16 16">
                            <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z"></path>
                        </svg>
                    </a>
                </div>
            </nav>
            <div class="text-sm text-slate-500 text-center sm:text-left">
                Mostrando <span class="font-medium text-slate-600">1</span> a <span class="font-medium text-slate-600">10</span> de <span class="font-medium text-slate-600">248</span> resultados
            </div>
        </div>
    </section>
</div>